import React from 'react';
import proptypes from 'prop-types';

import './base.scss';
import { Layout } from 'antd';
import Header from './header';
import SiteMenu from './site-menu';
import Footer from './footer';
import { useLocation } from 'react-router-dom';

const { Content } = Layout;

const Base = ({ children }) => {
  const location = useLocation();
  const { pathname } = location;
  const isShowBaseLayout = pathname !== '/login' && pathname !== '/auth/redirect';
  if (!isShowBaseLayout) {
    return children;
  }
  return (
    <Layout>
      <Header />
      <Layout>
        <SiteMenu />
        <Content className="main">{children}</Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

Base.propTypes = {
  children: proptypes.oneOfType([proptypes.object, proptypes.array]),
};

export default Base;
